const makeMarketSortedNames = (sort) => {
  if (!Array.isArray(sort)) {
    return sort;
  }
  const marketNames = [];
  sort == null ? void 0 : sort.forEach((element) => {
    marketNames.push(element.name);
  });
  return marketNames;
};
export {
  makeMarketSortedNames
};
